export const LOGIN_USER = 'LOGIN_USER';
export const REGISTER_USER = 'REGISTER_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const NETWORK_LOADING = 'NETWORK_LOADING';
export const NETWORK_ERROR = 'NETWORK_ERROR';
export const SET_USER = 'SET_USER';
export const VERIFY_USER = 'VERIFY_USER';